// Generated by ReScript, PLEASE EDIT WITH CARE

import * as OrderStage from "../entities/OrderStage.bs.js";
import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as TicketRaisedBy from "../entities/TicketRaisedBy.bs.js";
import * as TicketsResponse from "../entities/TicketsResponse.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  return {
          msisdn: Json_decode.optional((function (param) {
                  return Json_decode.field("msisdn", Json_decode.string, param);
                }), json),
          crn: Json_decode.optional((function (param) {
                  return Json_decode.field("crn", Json_decode.string, param);
                }), json),
          location: Json_decode.optional((function (param) {
                  return Json_decode.field("location", Json_decode.string, param);
                }), json),
          callerNumber: Json_decode.optional((function (param) {
                  return Json_decode.field("caller_number", Json_decode.string, param);
                }), json),
          orderStage: OrderStage.fromString(Json_decode.optional((function (param) {
                      return Json_decode.field("order_stage", Json_decode.string, param);
                    }), json)),
          raisedBy: TicketRaisedBy.fromString(Json_decode.optional((function (param) {
                      return Json_decode.field("raised_by", Json_decode.string, param);
                    }), json)),
          crtId: Json_decode.optional((function (param) {
                  return Json_decode.field("crt_id", Json_decode.string, param);
                }), json)
        };
}

var TicketsInfoStateMapper = {
  execute: execute
};

function execute$1(json) {
  return Json_decode.field("issues", (function (param) {
                return Json_decode.list(Json_decode.string, param);
              }), json);
}

var TicketIssueStateMapper = {
  execute: execute$1
};

function execute$2(json) {
  return Json_decode.field("actions", (function (param) {
                return Json_decode.list(Json_decode.string, param);
              }), json);
}

var TicketActionStateMapper = {
  execute: execute$2
};

function execute$3(json) {
  return {
          ticketId: Json_decode.field("ticket_id", Json_decode.string, json),
          message: Json_decode.field("message", Json_decode.string, json)
        };
}

var TicketRequestResponseStateMapper = {
  execute: execute$3
};

function execute$4(json) {
  return {
          case_number: Json_decode.field("case_number", Json_decode.string, json),
          crt_id: Json_decode.field("crt_id", Json_decode.string, json)
        };
}

var UpdateTicketRequestResponseStateMapper = {
  execute: execute$4
};

function execute$5(json) {
  return DeccoUtils$Catalyst.resolveResult(TicketsResponse.t_decode(json), "TicketsResponseMapper");
}

var TicketsResponseMapper = {
  execute: execute$5
};

export {
  TicketsInfoStateMapper ,
  TicketIssueStateMapper ,
  TicketActionStateMapper ,
  TicketRequestResponseStateMapper ,
  UpdateTicketRequestResponseStateMapper ,
  TicketsResponseMapper ,
  
}
/* TicketsResponse Not a pure module */
